'use client';

import cx from 'classnames';
import { useAtomValue } from 'jotai';

import DocumentSvg from '@flipster/ui/assets/svgs/document-search.svg';

import { filteredGlossaryTermsAtom } from '../jotai';
import styles from './index.module.scss';

const NoSearchResult = ({ className }: { className?: string }) => {
  const filteredGlossaryTerms = useAtomValue(filteredGlossaryTermsAtom);
  if (filteredGlossaryTerms.length) return;

  return (
    <section className={cx(styles.wrapper, className)} role='alert' aria-live='polite'>
      <DocumentSvg className={styles.image} />
      <h2 className={styles.text}>No available keyword</h2>
    </section>
  );
};

export default NoSearchResult;
